<template>
  <div>
    <img
      :src="require('@/assets/images/Group 2418.svg')"
      alt="自社HP経由登録"
      class="company-source-label"
    />
  </div>
</template>

<script>
export default {
  name: 'CompanyFrom',
};
</script>

<!-- <style scoped>
.company-source {
  background-color: #006c6b;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: 0.85em;
  color: #fff;
  height: 24px;
  width: fit-content;
  position: relative;
  margin: auto;
  display: inline-block;
}

.company-source::after {
  content: '';
  position: absolute;
  right: -10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #006c6b;
}
</style> -->
